<template>
  <div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      :busy="loading"
      ref="modal"
      title="Waiting for Login"
    >
      <div class="text-center">
        <b-spinner variant="primary"></b-spinner>
        <p>
          Phone approval needed for access. Reply with 1 to accept.
        </p>
      </div>

      <template v-slot:modal-footer>
        <b-button variant="info" @click="doSubmit">
           I've Agreed
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ApiService from "@/plugins/ApiService";
import { mapState } from "vuex";
import { SET_AUTH_INFO } from "@/store/mutation-types";

export default {
  name: "ChenosisLoginProcessModal",

  data() {
    return {
      phone: "",
      intervalId: null,
      transaction_id: null,
      type: null,
      loading:false
    };
  },

  computed: mapState(["errors", "onLine"]),

  methods: {
    create(id, phone, type) {
      this.$refs.modal.show();
      this.transaction_id = id;
      this.phone = phone;
      this.type = type;
      this.pollTransactionStatus();
    },

    async pollTransactionStatus() {
      try {
        
        const pollInterval = 10000; // Poll every 10 seconds (adjust as needed)
        this.intervalId = setInterval(async () => {
          const data = await this.requestPollingData();
          
          if (data.status === "success") {
            this.handleSuccessResponse(data);
          } else if (data.status === "error") {
            this.handleFailureResponse();

           } else if (data.status === "not_registered" ) {
            this.handleFailureResponse();
             
            swal.fire({
              text: `You need to register to create a radio`,
              confirmButtonText: "ok",
              confirmButtonColor: "#e64942",
              showCancelButton: false,
              focusCancel: true,
            }).then((result) => {
                window.location.href = process.env.VUE_APP_BASE_URL + '/pricing'
              
            });

            // console.log('not registered');

        }
        }, pollInterval);
      } catch (error) {
        this.loading = false

        this.handlePollingError(error);
      }
    },

    async doSubmit() {
      try {
        const data = await this.requestPollingData();
        if (data.status === "success") {
          this.handleSuccessResponse(data);
        } else if (data.status === "error") {
          this.handleFailureResponse();
        } else if (data.status === "not_registered") {
          this.handleFailureResponse();
           
            swal.fire({
            text: `Error: You need to register and create a radio`,
            confirmButtonText: "Ok",
            confirmButtonColor: "#e64942",
            showCancelButton: false,
            focusCancel: true,
          }).then((result) => {
              window.location.href = process.env.VUE_APP_BASE_URL + '/pricing'

          });

        }
      } catch (error) {
        this.loading = false

        this.handlePollingError(error);
      }
    },

    async requestPollingData() {
      this.loading = true

      const response = await ApiService.axios(
        false,
        "chenosis/polling",
        { transaction_id: this.transaction_id, phone: this.phone, type: this.type }
      );

      this.loading = false

      return response.data;
    },

    handleSuccessResponse(data) {

      console.log(data);
      clearInterval(this.intervalId);
      this.closeModal();
      const user = data.user;
      const access_token = data.access_token;
      this.$store.commit(SET_AUTH_INFO, { user, access_token });
      if (this.type== 'login') {
        this.$router.go("/", () => {});
        
      }else if (this.type== 'register'){

        //cannot create multiple stations for now
        if( this.authUser?.stations?.length > 0){
          this.$router.replace("/", () => {});
        }


      }
    },

    handleFailureResponse() {
      clearInterval(this.intervalId);
      this.closeModal();
    },

    handlePollingError(error) {
      console.error("poll err", error);
      // this.progressMessage = `Error Logging In: ${error.message}`;
      clearInterval(this.intervalId);
      this.closeModal();
    },

    closeModal() {
      this.$refs.modal.hide();
    },
  },
};
</script>
